<template>
    <b-container>
        <div class="text-center">
            <h1 class="h2">Your order is on its way.</h1>
            <h2 class="h4">Order no.: <strong>{{ order_no }}</strong></h2>
            <h2 class="h5">Table no.: <strong>{{ orderDetails.table_no }}</strong></h2>
            <p>You will receive an email shortly of your receipt and order.</p>
            <img style="height: 300px" class="d-block m-auto pt-4 pb-4" src="../../../src/assets/img/cooking.svg">
        </div>

        <b-card title="Order Items">
            <table class="table">
                <thead>
                <tr>
                    <th>Item</th>
                    <th>Price</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in orderDetails.order_items" :key="index">
                    <td>
                        {{ item.item_name }} (£{{ formatMoney(item.total_price)}})
                        <ul class="list p-0 list-unstyled">
                            <li v-for="(modifier, index) in item.selectedModifiers" :key="index">
                                <span class="text-muted small">{{ modifier.name }} (£{{formatMoney(modifier.price)}})</span>
                            </li>
                        </ul>
                    </td>
                    <td>£{{ formatMoney(item.total_price_with_modifiers) }}</td>
                </tr>
                </tbody>
            </table>

            <table class="table">
                <tr>
                    <th>Sub-total</th>
                    <td>£{{ formatMoney(orderDetails.sub_total) }}</td>
                </tr>
                <tr>
                    <th>Service charge</th>
                    <td>£{{ formatMoney(orderDetails.service_charge) }}</td>
                </tr>

                <tr v-if="orderDetails.tip">
                    <th>Tip</th>
                    <td>£{{ formatMoney(orderDetails.tip) }}</td>
                </tr>

                <tr>
                    <th>Total</th>
                    <td>£{{ formatMoney(orderDetails.total) }}</td>
                </tr>
            </table>
        </b-card>

        <router-link :to="{path: '/'}" class="mt-4 btn btn-primary btn-lg btn-block">Finish</router-link>
    </b-container>
</template>

<script>
    import store from './../../store';

    export default {
        name: "OrderPlaced",

        data() {
            return {
                order_no: this.$route.params.order_no,
                orderDetails: [],
            }
        },

        created() {
            store.commit('REMOVE_ALL_PRODUCTS');
        },

        mounted() {
            this.getOrderDetails()
        },

        methods: {
            getOrderDetails() {
                axios.get('/order/' + this.order_no).then(response => {
                    this.orderDetails = response.data
                    console.log(this.orderDetails);
                })
            },

            formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },
        }
    }
</script>

<style scoped>

</style>